import React from 'react';

import {SimpleActionButton} from 'components/form/components';
import {useTableReportParameters} from 'components/table-report/hooks/use-table-report-parameters';
import {ELocationStateKey, useAppHistory} from 'shared/hooks/use-app-history';
import {useAppDispatch} from 'store/config/hooks';
import {tableReportSliceActions} from 'store/slices/table-report-slice';

const {
    resetTableReportQueryParams,
} = tableReportSliceActions;

export const ResetDrillDownFilter = () => {
    const dispatch = useAppDispatch();
    const history = useAppHistory();

    const {passedParameters} = useTableReportParameters();
    const {DRILL_ID: drillId} = passedParameters;

    const handleResetDrillDownClick = () => {
        history.updateLocationState({
            [ELocationStateKey.TABLE_REPORT_PARAMS]: undefined,
        });

        dispatch(resetTableReportQueryParams());
    };

    return drillId ? (
        <SimpleActionButton
            type="primary"
            title="Сбросить ДД"
            onClick={handleResetDrillDownClick}
        />
    ) : null;
};
